module.exports = __webpack_public_path__ + "static/media/baseball.9e3ff5bc.svg";